import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PRODUCT_NAME = "ShopKaBot";
const WHATSAPP_NUMBER = "919768260471";
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  `Hey, I want to know more about ${PRODUCT_NAME}.`,
)}`;

const footerLinks = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "Blog", href: "/blogs" },
  { label: "Tools", href: "/tools" },
  { label: "Contact", href: "/contact-us" },
];

const legalLinks = [
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms", href: "/terms-of-service" },
];

export default function MarketingFooter() {
  const navigate = useNavigate();

  return (
    <footer className="border-t border-slate-100 bg-slate-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:py-12">
        <div className="grid gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-emerald-700">
              {PRODUCT_NAME}
            </p>
            <h2 className="mt-3 max-w-sm text-2xl font-semibold tracking-tight text-slate-900">
              Homepage-quality automation experience on every page.
            </h2>
            <p className="mt-3 max-w-md text-sm leading-7 text-slate-600">
              Sales, support, bookings, and content built around one clear brand:
              calm, trustworthy, and conversion-focused.
            </p>

            <div className="mt-5 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={() => navigate("/contact-us")}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-emerald-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-emerald-700"
              >
                Fill lead form <ArrowRight className="h-4 w-4" />
              </button>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center rounded-full border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-800 transition hover:border-emerald-200 hover:bg-emerald-50 hover:text-emerald-800"
              >
                WhatsApp us
              </a>
            </div>
          </div>

          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.16em] text-slate-900">
              Explore
            </p>
            <div className="mt-4 flex flex-col gap-3">
              {footerLinks.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className="text-sm text-slate-600 transition hover:text-emerald-700"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.16em] text-slate-900">
              Legal
            </p>
            <div className="mt-4 flex flex-col gap-3">
              {legalLinks.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className="text-sm text-slate-600 transition hover:text-emerald-700"
                >
                  {item.label}
                </Link>
              ))}
              <Link
                to="/contact-us"
                className="text-sm text-slate-600 transition hover:text-emerald-700"
              >
                Support
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-slate-200 pt-5 text-xs text-slate-500 md:flex-row md:items-center md:justify-between">
          <p>
            (c) {new Date().getFullYear()} {PRODUCT_NAME}. Built for smarter WhatsApp commerce.
          </p>
          <p>Consistent product design, trusted automation, and a cleaner buyer journey.</p>
        </div>
      </div>
    </footer>
  );
}
